import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import '../styles/App.css';

function LoginPage() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if admin is already logged in, redirect to admin dashboard
    const admin = localStorage.getItem('admin');
    const adminToken = localStorage.getItem('adminToken');
    if (admin && adminToken) {
      navigate('/admin/dashboard');
      return;
    }

    // אם המשתמש כבר מחובר (יש נתונים ב-localStorage), נווט אוטומטית לדף הפרופיל
    const user = localStorage.getItem('user');
    const userToken = localStorage.getItem('token');
    if (user && userToken) {
      navigate('/profile');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage('');
    setLoading(true);

    try {
      const response = await authAPI.loginUser(phone, password);

      if (response.success && response.user) {
        // Token and user data are already stored by authAPI.loginUser()
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const endDate = new Date(response.user.end_date);
        endDate.setHours(23, 59, 59, 999);

        if (endDate < currentDate) {
          // Subscription expired - clear localStorage and show error
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          setMessage('המנוי שלך פג. לחדש מנוי נא ליצור קשר עם מלאק.');
        } else {
          navigate('/profile');
        }
      } else {
        // Clear any stale data if login was not successful
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setMessage('נתוני המשתמש לא התקבלו כראוי.');
      }
    } catch (error) {
      // Clear localStorage on failed login
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      setMessage(error.response?.data?.error || 'שגיאה בהתחברות. אנא בדוק את הטלפון והסיסמה.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="Login-form">
      <img src="https://pilates-house.net/wp-content/uploads/2024/10/Untitled-3-e1729932468250.png" alt="Logo" />
      <h1>התחברות</h1>
      <form onSubmit={handleLogin}>
        <div>
          <label>טלפון:</label>
          <input
            type="text"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        <div>
          <label>סיסמה:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'מתחבר...' : 'התחבר'}
        </button>
      </form>
      {message && <p className="message">{message}</p>}
    </div>
  );
}

export default LoginPage;
